document.addEventListener('DOMContentLoaded', ()=>{
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const mediaThumbEl = document.querySelector('.type__product_thumb_swiper.swiper');
  if (mediaThumbEl){
    var MediaThumbnailView = new Swiper('.type__product_thumb_swiper.swiper', {spaceBetween:12,slidesPerView:'auto',watchSlidesProgress: true});
  }
  const mediaEl = document.querySelector('.type__product_main_swiper.swiper');
  if (mediaEl){
    const mediaConfig = {spaceBetween:0,slidesPerView:1,pagination:{el:'.swiper-pagination',type:'progressbar'},navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },thumbs: {swiper: MediaThumbnailView} };
    new Swiper(mediaEl, mediaConfig);
  }

  const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
  if (testimonialEl) {
    const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
    if (!isIOS) {
      testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
      testimonialConfig.freeMode = true;
    }
    new Swiper(testimonialEl, testimonialConfig);
  }

  if ( document.querySelectorAll('.table__featured__swiper.swiper').length > 0 ){
    document.querySelectorAll('.table__featured__swiper.swiper').forEach((swiperinitilize) => {
      new Swiper(swiperinitilize, {
        slidesPerView: 'auto',
        pagination: { el: ".swiper-pagination.pagination_table_chart", clickable: true },
        navigation: { nextEl: ".swiper-button-next.next_table_chart", prevEl: ".swiper-button-prev.prev_table_chart" }         
      });
    }); 
  }  
  
  const timelineItems = document.querySelectorAll('.timeline-item');
  const progressDots = document.querySelectorAll('.progress-dot');
  const progressBar = document.getElementById('progressBar');
  const progressContainer = document.querySelector('.progress-container');

  if (progressContainer || progressBar || timelineItems.length != 0 || progressDots.length != 0){
    function debounce(func, wait = 100) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
    function alignDotsToItems() {
      let cumulativeHeight = 0;
      timelineItems.forEach((item, index) => {
        const itemHeight = item.offsetHeight;
        const itemStyle = window.getComputedStyle(item);
        const marginBottom = parseFloat(itemStyle.marginBottom) || 0;
        if (progressDots[index]) {
          progressDots[index].style.top = `${cumulativeHeight}px`;
        }
        cumulativeHeight += itemHeight + marginBottom;
      });
      updateProgressBarHeight();
      adjustProgressContainerHeight();
    }
  
    function updateProgressBarHeight() {
      const activeDots = Array.from(progressDots).filter(dot => dot.classList.contains('active'));
      if (activeDots.length === 0) {
        progressBar.style.height = '0px';
        return;
      }
      const firstTop = parseFloat(progressDots[0].style.top) || 0;
      const lastActiveDot = activeDots[activeDots.length - 1];
      const lastTop = parseFloat(lastActiveDot.style.top) || 0;
      progressBar.style.top = `${firstTop}px`;
      progressBar.style.height = `${lastTop - firstTop}px`;
    }
  
    function setActiveDotByScroll() {
      const viewportCenter = window.innerHeight / 2;
      let activeIndex = 0;
      let minDistance = Infinity;
      timelineItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemMiddle = rect.top + rect.height / 2;
        const distance = Math.abs(itemMiddle - viewportCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });
      timelineItems.forEach((item, index) => {
        const isActive = index <= activeIndex;
        item.classList.toggle('center-stage', index === activeIndex);
        progressDots[index]?.classList.toggle('active', isActive);
      });
      updateProgressBarHeight();
    }
  
    function adjustProgressContainerHeight() {
      const firstDotTop = progressDots[0].offsetTop;
      const lastDot = progressDots[progressDots.length - 1];
      const lastDotTop = lastDot.offsetTop;
      const lastDotHeight = lastDot.offsetHeight;
      const lastDotStyle = window.getComputedStyle(lastDot);
      const lastDotMarginBottom = parseFloat(lastDotStyle.marginBottom) || 0;
      const height = (lastDotTop + lastDotHeight + lastDotMarginBottom) - firstDotTop;
      progressContainer.style.height = `${height}px`;
    }
    const updateLayout = () => {
      alignDotsToItems();
      setActiveDotByScroll();
    };
    const debouncedUpdate = debounce(updateLayout, 100);
    window.addEventListener('scroll', debounce(setActiveDotByScroll, 50));
    window.addEventListener('resize', debouncedUpdate);
    requestAnimationFrame(() => {
      debouncedUpdate();
      setTimeout(debouncedUpdate, 150);
    });
    const observer = new ResizeObserver(debouncedUpdate);
    timelineItems.forEach(item => observer.observe(item));
    let tries = 0;
    const maxTries = 10;
    const retryLoop = () => {
      debouncedUpdate();
      if (++tries < maxTries) {
        setTimeout(retryLoop, 300);
      }
    };
    retryLoop();
  }

  class PurchaseSelection extends HTMLElement {
    constructor() {
      super();
      this.attachEvents();
    }
    attachEvents() {
      this.querySelectorAll('.Purchase_one-time_title').forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const targetWrap = e.currentTarget.closest('.Purchase__normally_wy');
          const purchaseType = targetWrap.getAttribute('purchasetypeproduct');
          this.querySelectorAll('.Purchase__normally_wy').forEach(el => el.classList.remove('active'));
          targetWrap.classList.add('active');
          purchaseType === 'one-time' ? this.syncVariantsOneTime() : this.syncVariantsSubscribe();
        });
      });
  
      ['Size-onetime', 'Size-Subscribe'].forEach(name => {
        this.querySelectorAll(`input[name="${name}"]`).forEach(input => {
          input.addEventListener('change', () => {
            name === 'Size-onetime' ? this.syncVariantsOneTime() : this.syncVariantsSubscribe();
          });
        });
      });
  
      const addBtn = this.querySelector('.product-form__submit[name="add"]');
      if (addBtn) {
        addBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.querySelector('.purchaseOnetime_layoutWidget').classList.contains('active')
            ? this.productAddingCartOneTime()
            : this.productAddingCartSubscribe();
        });
      }
    }
    syncVariantsOneTime() {
      this.selectedValueOnetime();
      this.selectMasterVariant(this.choosedOneTime);
      this.UpdateAppearance('onetime');
    }
    syncVariantsSubscribe() {
      this.selectedValueSubscribe();
      this.selectMasterVariant(this.choosedSubscribe);
      this.UpdateAppearance('subscribe');
    }
    selectedValueOnetime() {
      this.choosedOneTime = [...this.querySelectorAll('input[name="Size-onetime"]:checked')].map(input => input.value);
    }
    selectedValueSubscribe() {
      this.choosedSubscribe = [...this.querySelectorAll('input[name="Size-Subscribe"]:checked')].map(input => input.value);
    }
    getVariantData() {
      return this.variantData ||= JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }
    // edited by Skio
    getProductData() {
      return this.productData ||= JSON.parse(this.querySelector('[data-product]').textContent);
    }
    selectMasterVariant(choices) {
      this.currentVariant = this.getVariantData().find(variant =>
        !variant.options.some((opt, idx) => opt !== choices[idx])
      );
    }
    UpdateAppearance(type) {
      const layoutClass = type === 'onetime' ? '.purchaseOnetime_layoutWidget' : '.purchaseSubscribe_layoutWidget';
      const pricesEl = this.querySelector(`${layoutClass} .Buy__onceprices`);
      const submitBtns = document.querySelectorAll(`.product-form__submit[type="submit"]`);
      const price = (value) => (value / 100).toFixed(2);
      if (!this.currentVariant) return;
      const comparePriceRaw = type === 'subscribe' ? (this.currentVariant.compare_at_price ? this.currentVariant.compare_at_price : this.currentVariant.price ) : this.currentVariant.compare_at_price;
      const priceRaw = type === 'subscribe' && this.currentVariant.selling_plan_allocations.length
        ? this.currentVariant.selling_plan_allocations[0].price
        : this.currentVariant.price;
      const hasDiscount = comparePriceRaw && comparePriceRaw > priceRaw;
      const comparePrice = hasDiscount ? price(comparePriceRaw) : null;
      let basePrice = 0,basePriceBeforeDiscount = 0,discountEl = 0,finalPriceEL = 0,basePriceAfterDiscount = 0,deafultOffBadge;

      if(type === 'subscribe'){
        discountEl = this.querySelector(`.shouldUsed__fordiscountv [data-variant-name="${this.currentVariant.title}"]`).dataset.subDiscount;
        if(discountEl){
          basePriceBeforeDiscount = price(comparePriceRaw);
          finalPriceEL = basePriceBeforeDiscount - discountEl; 
          basePriceAfterDiscount = finalPriceEL.toFixed(2); 
        }else{
          basePriceAfterDiscount = price(priceRaw);
        }
      }else{
        discountEl = this.querySelector(`.shouldUsed__fordiscountv [data-variant-name="${this.currentVariant.title}"]`).dataset.otpDisocunt;
        if(discountEl){
          basePriceBeforeDiscount = price(comparePriceRaw);
          finalPriceEL = basePriceBeforeDiscount - discountEl; 
          basePriceAfterDiscount = finalPriceEL.toFixed(2);
        }else{
          basePriceAfterDiscount = price(priceRaw);
        }
      }

      basePrice = basePriceAfterDiscount

      const isAvailable = this.currentVariant.available;
      const soldOut = !isAvailable;
      const priceHTML = hasDiscount
        ? `<span class="discounted_price">$${basePrice}</span>&nbsp;<span class="normal_price">$${comparePrice}</span>`
        : `<span class="exactly_price">$${basePrice}</span>`;
      const btnText = soldOut ? (hasDiscount ? `Sold Out — $${basePrice}&nbsp;<s>$${comparePrice}</s>` : `Sold Out — $${basePrice}`)  : (hasDiscount ? `Add to Cart — $${basePrice}&nbsp;<s>$${comparePrice}</s>` : `Add to Cart — $${basePrice}`);
      if (pricesEl) pricesEl.innerHTML = priceHTML;
      [...submitBtns].forEach(btn => {
        const label = btn.querySelector('.btn_txt_wp');
        if (label) label.innerHTML = btnText;
        btn.disabled = soldOut;
      });
      this.querySelector('[name="id"]').value = this.currentVariant.id;
      if (type === 'subscribe') {
        let planInput = this.querySelector('[name="selling_plan_id"]');
        if (!planInput) {
          planInput = document.createElement('input');
          planInput.type = 'hidden';
          planInput.name = 'selling_plan_id';
          this.appendChild(planInput);
        }
        // Filter to only use selling plans from app_id 5859381
        // edited by Skio
        const productData = this.getProductData();
        const filteredSellingPlanGroups = productData.selling_plan_groups.filter(selling_plan_group => 
          selling_plan_group.app_id === 'SKIO'
        );
        
        // Get valid selling plan IDs from filtered groups
        const validPlanIds = new Set();
        filteredSellingPlanGroups.forEach(group => {
          if (group.selling_plans) {
            group.selling_plans.forEach(plan => validPlanIds.add(plan.id));
          }
        });
        
        // Find first matching allocation
        const validAllocation = this.currentVariant.selling_plan_allocations.find(allocation =>
          validPlanIds.has(allocation.selling_plan_id)
        );
        
        if (validAllocation) {
          planInput.value = validAllocation.selling_plan_id;
        } else {
          console.warn('No selling plan allocations found for app_id SKIO');
          planInput.value = this.currentVariant.selling_plan_allocations[0].selling_plan_id; // fallback
        }
        // edited by Skio
      } else {
        const planInput = this.querySelector('[name="selling_plan_id"]');
        if (planInput) planInput.remove();
      }
    }
    productAddingCartOneTime() {
      this.handleAddToCart({
        id: this.querySelector('[name="id"]').value,
        quantity: 1,
      });
    }
    productAddingCartSubscribe() {
      this.handleAddToCart({
        id: this.querySelector('[name="id"]').value,
        quantity: 1,
        selling_plan: this.querySelector('[name="selling_plan_id"]').value
      });
    }
    handleAddToCart(item) {
      const submitBtn = this.querySelector('.product-form__submit[name="add"]');
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.enableLoading();
      const bundleCart = {
        items: [item],
        sections: cartDrawer?.getSectionsToRender()?.map(s => s.section) || [],
        sections_url: window.location.pathname
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(bundleCart),
        credentials: 'same-origin'
      }).then(res => res.json())
        .then(data => cartDrawer?.renderContent(data.sections))
        .catch(console.error)
        .finally(() => {
          if (cartDrawer) {
            cartDrawer.disableLoading();
            cartDrawer.open();
          }
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
        });
    }
  }
  customElements.define('cus-selection-variants', PurchaseSelection);

  if( document.querySelectorAll('.video__playIcon').length > 0 ){
    document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
      })
    });
    document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
      })
    });  
  }

  if( document.querySelectorAll('[js-doctor-dietitian-lightbox]').length > 0 ){
    document.querySelectorAll('[js-doctor-dietitian-lightbox]').forEach((elm)=>{
      elm.addEventListener('click',(target)=>{
        target.preventDefault();
        let lighhtbox_doctor = document.querySelector('.doctor_dietitian_lightbox_html').innerHTML;
        document.querySelector('.doctor_dietitian_lightbox').innerHTML = lighhtbox_doctor;
        document.querySelector('.doctor_dietitian_lightbox').classList.add('active');
        document.querySelector('.page-overlay').classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
      })
    })   
  }
  
  class doctorDietitian extends HTMLElement{
    constructor(){
      super();
      this.querySelectorAll('[js-doctor-dietitian-lightbox-close]').forEach((elm)=>{
        elm.addEventListener('click',(target)=>{
          target.preventDefault();
          document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``;
          document.querySelector('.doctor_dietitian_lightbox').classList.remove('active');
          document.querySelector('.page-overlay').classList.remove('is-visible');
          document.body.classList.remove('overflow-hidden');
        })
      })       
    }
  }
  window.customElements.define('cus-dietitian-widget',doctorDietitian);  

  function setupMarquee({ contentId, containerSelector, speed = 0.5 }) {
    const scrollingContent = document.getElementById(contentId);
    if (!scrollingContent) {
      console.warn(`Marquee setup failed: Element with ID "${contentId}" not found.`);
      return;
    }
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Marquee setup failed: Container with selector "${containerSelector}" not found.`);
      return;
    }
    scrollingContent.innerHTML += scrollingContent.innerHTML;
    let x = 0;
    let isPaused = false;
    function animate() {
      if (!isPaused) {
        x -= speed;
        if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
          x = 0;
        }
        scrollingContent.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(animate);
    }
    container.addEventListener("mouseenter", () => { isPaused = true; });
    container.addEventListener("mouseleave", () => { isPaused = false; });
    animate();
  }
  setupMarquee({ contentId: "scrollingContent", containerSelector: ".squeeze_scroller_main", speed: 0.5 });

  if( document.querySelectorAll('a[href*="/type__pdp_main_wrapper"]').length > 0 ){
    document.querySelectorAll('a[href*="/type__pdp_main_wrapper"]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        const dynamicAttribute = event.target.getAttribute('href').split('/')[1];
        const targetElement = document.querySelector(`.${dynamicAttribute}`);
        const sectionHeader = document.querySelector('.section-header');
        if (!targetElement || !sectionHeader) return;
        const totalTop = sectionHeader.clientHeight;
        window.scrollTo({
          top: targetElement.offsetTop - totalTop,
          behavior: 'smooth'
        });
      });
    });
  } 

  if( document.querySelectorAll('[js-scroll-pdp-section]').length > 0 ){
    document.querySelectorAll('[js-scroll-pdp-section]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        const targetElement = document.querySelector(`.type__pdp_main_wrapper`);
        const sectionHeader = document.querySelector('.section-header');
        if (!targetElement || !sectionHeader) return;
        const totalTop = sectionHeader.clientHeight;
        window.scrollTo({
          top: targetElement.offsetTop - totalTop,
          behavior: 'smooth'
        });
      });
    });
  } 

  if( document.querySelectorAll('.Testimonial_button_reviews').length > 0 ){
    document.querySelectorAll('.Testimonial_button_reviews').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        const targetElementRv = document.querySelector(`[data-section-type="page-reviews"]`);
        const sectionHeaderRv = document.querySelector('.section-header');
        if (!targetElementRv || !sectionHeaderRv) return;
        const totalTopRv = sectionHeaderRv.clientHeight;
        window.scrollTo({
          top: targetElementRv.offsetTop - totalTopRv,
          behavior: 'smooth'
        });        
      })
    })
  }

  const REVIEW_API_BASE = 'https://api.okendo.io/v1';
  const STORE_ID = 'ddccf316-2614-49f7-8641-7b411da6bacb';
  const COLLECTION_ID = 'c95c5011-c412-4f6c-bc87-cdb7a8e9b16e';
  const INITIAL_API_URL = `${REVIEW_API_BASE}/stores/${STORE_ID}/collections/${COLLECTION_ID}/reviews`;
  const loadMoreReviewsBtn = document.getElementById('load-more-reviews');
  const reviewContainer = document.getElementById('chronic-review-container');
  let nextUrl = null;
  
  function toggleLoadMore(url) {
    if (!loadMoreReviewsBtn) return;
    loadMoreReviewsBtn.classList.toggle('hidden', !url);
  }
  
  function createReviewItem(item) {
    const gridItem = document.createElement('div');
    gridItem.className = 'review-grid-item';
    const avatarUrl = item?.reviewer?.avatarUrl || item?.productImageUrl || '';
    const avatarAlt = item?.reviewer?.displayName || item?.productName || 'avatar';
    const avatar = `<img style="width: 72px; height: 72px; object-fit: cover; border-radius: 5px;" alt="${avatarAlt}" src="${avatarUrl}"> `;
    const ratingPercent = `${(item?.rating || 0) * 20}%`;
    gridItem.innerHTML = `
      <span class="okeReviews-starRating-indicator" role="presentation rating-${item?.rating}">
        <span class="okeReviews-starRating-indicator-layer"></span>
        <span class="okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground" style="width: ${ratingPercent}"></span>
      </span>
      <h3>${item?.title || ''}</h3>
      <p>${item?.body || ''}</p>
      <p style="display: flex; align-items: center; gap: 16px;">${avatar}<span>${item?.reviewer?.displayName || ''}</span></p>
    `;
    return gridItem;
  }
  
  function loadReviews(data, setPosition = false) {
    const reviews = data?.reviews;
    if (!reviews?.length || !reviewContainer) return;
    const fragment = document.createDocumentFragment();
    reviews.forEach(item => {
      const reviewEl = createReviewItem(item);
      fragment.appendChild(reviewEl);
    });
    reviewContainer.appendChild(fragment);
    if (setPosition) {
      const promoBanner = reviewContainer.querySelector('.promo__banner');
      const thirdReview = reviewContainer.querySelectorAll('.review-grid-item')[2];
      if (promoBanner && thirdReview) {
        reviewContainer.insertBefore(promoBanner, thirdReview);
      }
    }
    nextUrl = data?.nextUrl ? `${REVIEW_API_BASE}${data.nextUrl}` : null;
    toggleLoadMore(nextUrl);
  }
  
  async function fetchReviews(url = INITIAL_API_URL) {
    try {
      const response = await fetch(url);
      return await response.json();
    } catch (error) {
      console.error('Error fetching reviews:', error);
      return null;
    }
  }
  
  (async () => {
    const data = await fetchReviews();
    if (data) {
      loadReviews(data, true);
    }
  })();
  
  if (loadMoreReviewsBtn) {
    loadMoreReviewsBtn.addEventListener('click', async () => {
      if (!nextUrl) return;
      loadMoreReviewsBtn.disabled = true;
      const moreData = await fetchReviews(nextUrl);
      if (moreData) {
        loadReviews(moreData);
      }
      loadMoreReviewsBtn.disabled = false;
    });
  }  
  
})